import { render } from "./ListPickupPage.vue?vue&type=template&id=8fdd1562&ts=true"
import script from "./ListPickupPage.vue?vue&type=script&lang=ts"
export * from "./ListPickupPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__